import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { LocalStorageService } from 'src/app/global/services/localstorage.service';
import { UafService } from 'src/app/global/services/uaf.service';
import { DialogService } from 'src/app/view-model/services/dialog.service';
import { rutValidator } from 'src/app/view-model/validators/rut.validator';
import { rutEmpresaValidator } from 'src/app/view-model/validators/rutempresa.validator';
import { vulgarFractionValidator } from 'src/app/view-model/validators/vulgarFraction.validator';
import { throwError } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';

@Component({
  selector: 'app-form-uaf',
  templateUrl: './form-uaf.component.html',
  styleUrls: ['./form-uaf.component.scss']
})

export class FormUafComponent implements OnInit {
  display = 'none';
  public formAntecedentesPersona: FormGroup;
  public formAntecedentesDeclarante: FormGroup;
  public formModal: FormGroup;
  fecha: Date = new Date();
  meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
  public txtFecha: string = 'A ' + this.fecha.getUTCDate() + ' de ' + this.meses[this.fecha.getMonth()] + ' de ' + this.fecha.getUTCFullYear();
  beneficiariosFinalesList = [];
  controlEfectivoList = [];
  tituloModal: String;
  isBeneficiario: boolean;
  registroEdit;
  cargando = true;
  guardando = false;
  participacionBeneficiarioOk = true;
  participacionControlOk = true;


  constructor(
    protected dialogService: DialogService,
    private  uafService: UafService,
    private router: Router,
    private localStorageService: LocalStorageService,
  ) { dialogService; }

  ngOnInit() {
    this.formAntecedentesPersona = new FormGroup({
      rutEmpresa: new FormControl('', rutEmpresaValidator),
      razonSocial: new FormControl('', vulgarFractionValidator),
      domicilio: new FormControl('', vulgarFractionValidator),
      ciudad: new FormControl(''),
      paisConstitucion: new FormControl(''),
      telefono: new FormControl(''),
      rutRepresentante: new FormControl('', rutValidator),
      nombreRepresentate: new FormControl(''),
      tipoEntidad: new FormControl('')
    });
    this.formAntecedentesDeclarante = new FormGroup({
      nacionalidad: new FormControl(''),
      rutDeclarante: new FormControl('', rutValidator),
      nombreDeclarante: new FormControl(''),
      apellidoPaterno: new FormControl(''),
      apellidoMaterno: new FormControl(''),
      lugarOrigen: new FormControl(''),
      relacionDeclarante: new FormControl('')
    });
    this.formModal = new FormGroup({
      rutModal: new FormControl('', rutValidator),
      nombreModal: new FormControl(''),
      domicilioModal: new FormControl('', vulgarFractionValidator),
      ciudadModal: new FormControl(''),
      paisConstitucion: new FormControl(''),
      participacionModal: new FormControl('')
    });
    this.getDeclaracion();
  }

  addBeneficiario() {
    const beneficiarioFinal = this.obtieneDataModal();
    const index = this.beneficiariosFinalesList.indexOf(this.registroEdit);
    if (index < 0) {
      this.beneficiariosFinalesList.push(beneficiarioFinal);
    } else {
      this.beneficiariosFinalesList[index] = beneficiarioFinal;
      this.registroEdit = undefined;
    }
    this.closeModal();
  }

  addControlEfectivo() {
    const controlEfectivo = this.obtieneDataModal();
    const index = this.controlEfectivoList.indexOf(this.registroEdit);
    if (index < 0) {
      this.controlEfectivoList.push(controlEfectivo);
    } else {
      this.controlEfectivoList[index] = controlEfectivo;
    }
    this.closeModal();
  }

  obtieneDataModal (){
    const data = {
      rut: this.formModal.get('rutModal').value,
      nombre: this.formModal.get('nombreModal').value,
      domicilio: this.formModal.get('domicilioModal').value,
      ciudad: this.formModal.get('ciudadModal').value,
      pais: this.formModal.get('paisConstitucion').value,
      participacion: this.formModal.get('participacionModal').value
    };
    return data;
  }

  closeModal() {
    this.registroEdit = undefined;
    this.display = 'none';
  }

  getDeclaracion() {
    const fnSuccess = (declaracionUaf: any) => {
      this.mapearDeclaracionObtenida(declaracionUaf.data);
    };
    const fnFailure = (error: any) => {
      console.error(error);
    };
    this.uafService.getDeclaracion().subscribe(fnSuccess, fnFailure);
  }

  mapearDeclaracionObtenida(declaracionObtenida: any) {
    if (declaracionObtenida) {
      // Mapeo Antecedentes Persona
      this.formAntecedentesPersona.get('rutEmpresa').setValue(declaracionObtenida.rut);
      this.formAntecedentesPersona.get('razonSocial').setValue(declaracionObtenida.razonSocial);
      this.formAntecedentesPersona.get('domicilio').setValue(declaracionObtenida.domicilio);
      this.formAntecedentesPersona.get('ciudad').setValue(declaracionObtenida.ciudad);
      this.formAntecedentesPersona.get('paisConstitucion').setValue(declaracionObtenida.pais);
      this.formAntecedentesPersona.get('telefono').setValue(declaracionObtenida.telefono);

      this.formAntecedentesPersona.get('tipoEntidad').setValue(declaracionObtenida.tipoEntidad);

      if (declaracionObtenida.representante) {
        this.formAntecedentesPersona.get('rutRepresentante').setValue(declaracionObtenida.representante.rut);
        this.formAntecedentesPersona.get('nombreRepresentate').setValue(declaracionObtenida.representante.nombre);
      }
      // Mapeo Beneficiarios
      this.beneficiariosFinalesList = declaracionObtenida.beneficiariosFinales;
      // Mapeo Control Efectivo
      this.controlEfectivoList = declaracionObtenida.controlEfectivo;
      // Mapeo Persona Natural
      if (declaracionObtenida.declarante) {
        this.formAntecedentesDeclarante.get('nacionalidad').setValue(declaracionObtenida.declarante.nacionalidad);
        this.formAntecedentesDeclarante.get('rutDeclarante').setValue(declaracionObtenida.declarante.rut);
        this.formAntecedentesDeclarante.get('nombreDeclarante').setValue(declaracionObtenida.declarante.nombre);
        this.formAntecedentesDeclarante.get('apellidoPaterno').setValue(declaracionObtenida.declarante.apellidoPaterno);
        this.formAntecedentesDeclarante.get('apellidoMaterno').setValue(declaracionObtenida.declarante.apellidoMaterno);
        this.formAntecedentesDeclarante.get('lugarOrigen').setValue(declaracionObtenida.declarante.lugarOrigen);
        this.formAntecedentesDeclarante.get('relacionDeclarante').setValue(declaracionObtenida.declarante.relacion);
      }
    }
    this.cargando = false;
  }


  saveDeclaracion(): void {
    if (this.formAntecedentesPersona.invalid || this.formAntecedentesDeclarante.invalid) {
      console.warn('Formulario inválido', {
        persona: this.formAntecedentesPersona.errors,
        declarante: this.formAntecedentesDeclarante.errors
      });
      return;
    }
  
    this.guardando = true;
  
    const declaracion = this.buildDeclaracionPayload();
  
    this.uafService.saveDeclaracion(declaracion).pipe(
      tap(response => {
        console.log('Declaración guardada con éxito', response);
        this.volver();
      }),
      catchError(err => {
        console.error('Error al guardar declaración:', err);
        const title = err.error.mensaje.titulo || 'Error inesperado';
        const content = err.error.mensaje.contenido || 'Por favor, inténtalo de nuevo más tarde.';
        this.dialogService.openErrorDialog(title, content);
        return throwError(() => err);
      }),
      finalize(() => {
        this.guardando = false;
      })
    ).subscribe();
  }
  
  /** Extrae el mapeo de formulario a un método aparte */
  private buildDeclaracionPayload(): any {
    const persona = this.formAntecedentesPersona.value;
    const declarante = this.formAntecedentesDeclarante.value;
  
    return {
      rut:              persona.rutEmpresa,
      razonSocial:      persona.razonSocial,
      domicilio:        persona.domicilio,
      ciudad:           persona.ciudad,
      pais:             persona.paisConstitucion,
      telefono:         persona.telefono,
      tipoEntidad:      persona.tipoEntidad,
      beneficiariosFinales: this.beneficiariosFinalesList,
      controlEfectivo:  this.controlEfectivoList,
      representante: {
        rut:    persona.rutRepresentante,
        nombre: persona.nombreRepresentate
      },
      declarante: {
        nacionalidad:    declarante.nacionalidad,
        rut:             declarante.rutDeclarante,
        nombre:          declarante.nombreDeclarante,
        apellidoPaterno: declarante.apellidoPaterno,
        apellidoMaterno: declarante.apellidoMaterno,
        lugarOrigen:     declarante.lugarOrigen,
        relacion:        declarante.relacionDeclarante
      }
    };
  }

  editarRegistroTabla(isBeneficiario: boolean, registro: any) {
    this.formModal.get('rutModal').setValue(registro.rut);
    this.formModal.get('nombreModal').setValue(registro.nombre);
    this.formModal.get('domicilioModal').setValue(registro.domicilio);
    this.formModal.get('ciudadModal').setValue(registro.domicilio);
    this.formModal.get('paisConstitucion').setValue(registro.pais);
    this.formModal.get('participacionModal').setValue(registro.participacion);
    this.registroEdit = registro;
    this.openModal(isBeneficiario, false);
  }

  eliminarRegistroTabla(isBeneficiario: boolean, registro: any) {
    if (isBeneficiario) {
      const index = this.beneficiariosFinalesList.indexOf(registro);
      this.beneficiariosFinalesList.splice(index, 1);
      return;
    }
    const index = this.controlEfectivoList.indexOf(registro);
    this.controlEfectivoList.splice(index, 1);
  }

  openModal(isBeneficiario: boolean, isNuevo: boolean) {
    if (isNuevo) {
      this.formModal.reset();
      this.participacionBeneficiarioOk = true;
      this.participacionControlOk = true;
    }

    this.display = 'block';
    if (isBeneficiario) {
      this.tituloModal = 'Agregar Beneficiario Final';
      this.isBeneficiario = isBeneficiario;
      return;
    }
    this.tituloModal = 'Agregar Control Efectivo';
    this.isBeneficiario = isBeneficiario;
  }

  volver() {
    localStorage.setItem('spinner', 'formularioUAF');
    this.router.navigate(['/']);
  }

  validateParticipacion(field) {
    var valor =  +this.formModal.get(field).value;

    if(this.isBeneficiario){
      if( valor < 10 ||  this.isBeneficiario && valor > 100){
        this.participacionBeneficiarioOk = false;
      }else{
        this.participacionBeneficiarioOk = true;
      }
    } else{
      if ( valor < 0 || !this.isBeneficiario && valor > 9){
        this.participacionControlOk = false;
      }else{
        this.participacionControlOk = true;
      }
    }
    
  }

  validaModalData(){
    var dataOk = Object.values(this.obtieneDataModal()).every(v => (v !== null && v !== ''));
    if(this.isBeneficiario){
      if(dataOk && this.participacionBeneficiarioOk){
        return false;
      }
      return true;
    }else {
      if(dataOk && this.participacionControlOk){
        return false;
      }
      return true;
    }

    
  }

} 
